export default function getDailyTasks(day){
    const dailyTasks = [1,1,1];

    for(let i=0; i<day; i++){
        dailyTasks.push(1,)
    }
    return dailyTasks
}